import React, { useEffect, useRef, useState } from 'react'
import officeImg from '../assets//office.png'
import billBoard_gardenImg from '../assets/billBoard_garden.png'
import billBoard_homeImg from '../assets/billBoard_home1.png'
import billBoard_officeImg from '../assets/billBoard_office.png'
import billBoard_playgroundImg from '../assets/billBoard_playground.png'
import gardenImg from '../assets/garden.png'
// Import of all img/object assets
import bk from '../assets/grassyBK.png'
import homeImg from '../assets/home.png'
import playerImg from "../assets/smallPlayer.png";
import playgroundImg from '../assets/playground.png'
import rockImg from '../assets/rock.png'
import schoolImg from '../assets/school.png'
import treeImg from '../assets/tree.png'
import waterFountain from '../assets/waterFountain.png'
import waterWell from '../assets/waterWell.png'
import './InstructionButton.css'
import Modal from './Modals'

// import './InstructionButton.css'


const NewCanvas = () => {
    const [dimensions, setDimensions] = useState({ 
        height: window.innerHeight,
        width: window.innerWidth
      })
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalID, setModalID] = useState(8);
    const [collisionOccur, setCollisionOccur] = useState(0);
    const [lastPlayerStates, setLastPlayerStates] = useState({})


    const canvasRef = useRef(null)
    const imgRef = useRef(null)
    const playerRef = useRef(null)
    const homeRef = useRef(null)
    const schoolRef = useRef(null)
    const waterFountainRef = useRef(null)
    const waterWellRef = useRef(null)
    const rockRef = useRef(null)
    const treeRef = useRef(null)
    const playgroundRef = useRef(null)
    const officeRef = useRef(null)
    const gardenRef = useRef(null)
    const billBoard_officeRef = useRef(null)
    const billBoard_homeRef = useRef(null)
    const billBoard_playgroundRef = useRef(null)
    const billBoard_gardenRef = useRef(null)
    

    const showModal = (modalID) => {
        setIsModalOpen(true);
        setModalID(modalID);

        // window.removeEventListener("keydown", onKeyPressHandler)
      };
    
      const hideModal = () => {
        setIsModalOpen(false);
        setCollisionOccur(0)
        // window.addEventListener("keydown", onKeyPressHandler)
      };
    

      const isEmpty = (obj) => {
        for(var i in obj) return false;
        return true
    }

    useEffect(()=>{
      showModal(8)
    },[])


    useEffect(()=> {
        if(collisionOccur !== 0){
            showModal(collisionOccur)
        }

        // if(collisionOccur === 1){
        //     // alert("colll--->1")
        //     showModal(1)
        //     //console.log("COOOOOOOOLLLL------>>>111111");
        //     // setCollisionOccur(0)
        // }else if(collisionOccur === 2){
        //     showModal(2)
        //     // alert("colll--->2")
        //     //console.log("COOOOOOOOLLLLLLLLLL----->22222222");
        //     // setCollisionOccur(0)
        // }
    }, [collisionOccur])

    
    

      useEffect(() => {

        // THis will occur after resize to initialize the canvas width and height again. STARTS
        var resizeTimer;
        const handleResize = () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function() {

    // Run code here, resizing has "stopped"
            // console.log('now will resize');
            window.location.reload(false);
            //  setDimensions({
            //     height: window.innerHeight,
            //     width: window.innerWidth
            //   })
  }, 500);  
            
           
        }
        
        // THis will occur after resize to initialize the canvas width and height again. ENDS
      const canvasStates = {
        width: dimensions.width - 10,
        height: dimensions.height - 10,
      };
      // console.log(playerRef.current)
        // All objects states/positiona and properties. _STARTS
        var player = {}
        if(!isEmpty(lastPlayerStates)){
            player = lastPlayerStates;
        }else{
            player = {
              x: (canvasStates.width * 69) / 100,
              y: (canvasStates.height * 76) / 100,
              width: 25,
              height: 37.5,
              frameX: 0,
              frameY: 0,
              speed: 4,
              moving: false,
            };
            // player = {
            //   x: (canvasStates.width * 70) / 100,
            //   y: (canvasStates.height * 75) / 100,
            //   width: 32,
            //   height: 48,
            //   frameX: 1,
            //   frameY: 3,
            //   speed: 5,
            //   moving: false,
            // };
        }
       
        
        const home = {
          x: (canvasStates.width * 80) / 100,
          y: (canvasStates.height * 72) / 100,
          width: (canvasStates.width * 12) / 100,
          height: (canvasStates.height * 15) / 100,
        };
        const garden = {
          x: (canvasStates.width * 5) / 100,
          y: (canvasStates.height * 75) / 100,
          width: (canvasStates.width * 15) / 100,
          height: (canvasStates.height * 20) / 100,
        };
        
        const school = {
          x: (canvasStates.width * 85) / 100,
          // x: canvasStates.width-(canvasStates.width -20),
          y: (canvasStates.height * 45) / 100,
          width: (canvasStates.width * 10) / 100,
          height: (canvasStates.height * 15) / 100,
        };
        const playground = {
          x: (canvasStates.width * 40) / 100,
          y: (canvasStates.height * 52) / 100,
          width: (canvasStates.width * 15) / 100,
          height: (canvasStates.height * 20) / 100,
        };
        const office = {
          x: (canvasStates.width * 0) / 100,
          y: (canvasStates.height * 42) / 100,
          width: (canvasStates.width * 11) / 100,
          height: (canvasStates.height * 22) / 100,
          //   width: 300,
          //   height: 250,
        };
        const obstacles = {
          billBoard_office: {
            x: (canvasStates.width * 1) / 100,
            y: (canvasStates.height * 52) / 100,
            width: (canvasStates.width * 5) / 100,
            height: (canvasStates.height * 12) / 100,
          },
          rock1: {
            x: (canvasStates.width * 40) / 100,
            y: (canvasStates.height * 85) / 100,
            width: (canvasStates.width * 3) / 100,
            height: (canvasStates.width * 3) / 100,
          },
          rock2: {
            x: (canvasStates.width * 65) / 100,
            y: (canvasStates.height * 60) / 100,
            width: (canvasStates.width * 2) / 100,
            height: (canvasStates.width * 2) / 100,
          },
          billBoard_home: {
            x: (canvasStates.width * 89) / 100,
            y: (canvasStates.height * 79) / 100,
            width: (canvasStates.width * 3) / 100,
            height: (canvasStates.height * 10) / 100,
          },
          billBoard_playground: {
            x: (canvasStates.width * 40) / 100,
            y: (canvasStates.height * 60) / 100,
            width: (canvasStates.width * 5) / 100,
            height: (canvasStates.height * 12) / 100,
          },
          billBoard_garden: {
            x: (canvasStates.width * 10) / 100,
            y: (canvasStates.height * 71) / 100,
            width: (canvasStates.width * 5) / 100,
            height: (canvasStates.height * 17) / 100,
          },
          waterFountain1: {
            x: (canvasStates.width * 92) / 100,
            y: (canvasStates.height * 68) / 100,
            width: (canvasStates.width * 4) / 100,
            height: (canvasStates.height * 8) / 100,
          },
          waterFountain2: {
            x: (canvasStates.width * 25) / 100,
            y: (canvasStates.height * 55) / 100,
            width: (canvasStates.width * 5) / 100,
            height: (canvasStates.height * 10) / 100,
          },
          waterWell1: {
            x: (canvasStates.width * 65) / 100,
            y: (canvasStates.height * 85) / 100,
            width: (canvasStates.width * 4) / 100,
            height: (canvasStates.height * 8) / 100,
          },
          tree1: {
            x: (canvasStates.width * 90) / 100,
            y: (canvasStates.height * 50) / 100,
            width: (canvasStates.width * 8) / 100,
            height: (canvasStates.height * 15) / 100,
          },
          tree2: {
            x: (canvasStates.width * 50) / 100,
            y: (canvasStates.height * 50) / 100,
            width: (canvasStates.width * 8) / 100,
            height: (canvasStates.height * 15) / 100,
          },
        };
        const keys = []

         // All objects states/positiona and properties. _ENDS

        const onKeyPressHandler = (e) => {
            if(e.keyCode === 37 || e.keyCode === 38 || e.keyCode === 39 || e.keyCode === 40){
                keys[e.keyCode] = true;
           //console.log(e);
           }else if(e.keyCode){    
               stopMovingAfterCollision()

           }
          
        }

        if(isModalOpen){
           window.removeEventListener("keydown", onKeyPressHandler)
        }
        else{
            window.addEventListener("keydown", onKeyPressHandler)
            
        }
        
       
        window.addEventListener("keyup", function(e){
            delete keys[e.keyCode]
            player.moving = false
            ////console.log( keys[e.key] );
        })

        window.addEventListener('resize', handleResize)
       

       

        const collisionDetection = (rect1, rect2) => {

            if (rect1.x > rect2.x + rect2.width ||
                rect1.x + rect1.width < rect2.x ||
                rect1.y > rect2.y + rect2.height || 
                rect1.y + rect1.height < rect2.y){
                    
                    setLastPlayerStates(player)
                    return false
                }else{
                    
                    setLastPlayerStates(player)
                    return true
                    
                }
        }

        const obstacleDetection = (player, obstacles) => {
            for (const key in obstacles) {
                if(collisionDetection(player, {...obstacles[key],   height: obstacles[key].height - 37.5,})){
                    return true;
                }
                //console.log(obstacles[key]);
            }
            return false;
        }

        const stopMovingAfterCollision = () => {
            player.moving = false;
            delete keys[37]
            delete keys[38]
            delete keys[39]
            delete keys[40]
        }

        const background  = imgRef.current;
        const playerSprite = playerRef.current;
        const homeSprite = homeRef.current
        const schoolSprite = schoolRef.current
        const waterFountainSprite = waterFountainRef.current
        const waterWellSprite = waterWellRef.current
        const rockSprite = rockRef.current
        const treeSprite = treeRef.current
        const playgroundSprite = playgroundRef.current
        const officeSprite = officeRef.current
        const gardenSprite = gardenRef.current
        const billBoard_officeSprite = billBoard_officeRef.current
        const billBoard_homeSprite = billBoard_homeRef.current
        const billBoard_playgroundSprite = billBoard_playgroundRef.current
        const billBoard_gardenSprite = billBoard_gardenRef.current
        const canvas = canvasRef.current
        const ctx = canvas.getContext('2d')
        canvas.width = canvasStates.width;
        canvas.height = canvasStates.height;
        let frameCount = 0
        let animationFrameId


        const collisionDetectionWithBuilding = (player) => {
            if(collisionDetection(player, {...home, height: home.height-37.5})){
                stopMovingAfterCollision()
                setCollisionOccur(1) 
                return true;
            }
            else if(collisionDetection(player, {...school, height: school.height-37.5})){
                stopMovingAfterCollision()
                setCollisionOccur(2) 
                return true;
            }
            else if(collisionDetection(player, {...playground, height: playground.height-37.5})){
                stopMovingAfterCollision()
                setCollisionOccur(3) 
                return true;
            }
            else if(collisionDetection(player, {...office, width: office.width-50, height: office.height-37.5})){
                stopMovingAfterCollision()
                setCollisionOccur(4) 
                return true;
            }
            else if(collisionDetection(player, {...garden,  height: garden.height-37.5})){
                stopMovingAfterCollision()
                setCollisionOccur(5) 
                return true;
            }
            else if(obstacleDetection(player, obstacles)){
                return true;
            }
        }



        const getCursorPosition = (canvas , e) => {
            const rect = canvas.getBoundingClientRect()
            const x = e.clientX - rect.left
            const y = e.clientY - rect.top
            // console.log("x: " + x + " y: " + y)
            
            collisionDetectionWithBuilding({x: x, y:y, width:0, height: 0})
            if(collisionDetection(player, {x: x, y:y, width:0, height: 0})){
                setCollisionOccur(7)
                // console.log('AMARE DHORONAA');
            }
            //Special case for hobby field as it has low height for mouse click
            if(collisionDetection({x: x, y:y, width:0, height: 0}, garden)){
                stopMovingAfterCollision()
                setCollisionOccur(5) 
                // return true;
            }
            
        }
        canvas.addEventListener('mousedown', function(e) {
            getCursorPosition(canvas, e)
        })


        const drawSprite = (img, sX, sY, sW, sH, dX, dY, dW, dH) => {
            ctx.drawImage(img, sX, sY, sW, sH, dX, dY, dW, dH)
        }
        
        const drawObstacles = () => {
            ctx.drawImage(waterFountainSprite, obstacles.waterFountain1.x, obstacles.waterFountain1.y, obstacles.waterFountain1.width, obstacles.waterFountain1.height)
            ctx.drawImage(waterFountainSprite, obstacles.waterFountain2.x, obstacles.waterFountain2.y, obstacles.waterFountain2.width, obstacles.waterFountain2.height)
            ctx.drawImage(waterWellSprite, obstacles.waterWell1.x, obstacles.waterWell1.y, obstacles.waterWell1.width, obstacles.waterWell1.height)
            ctx.drawImage(treeSprite, obstacles.tree1.x, obstacles.tree1.y, obstacles.tree1.width, obstacles.tree1.height)
            ctx.drawImage(treeSprite, obstacles.tree2.x, obstacles.tree2.y, obstacles.tree2.width, obstacles.tree2.height)
            ctx.drawImage(billBoard_officeSprite, obstacles.billBoard_office.x, obstacles.billBoard_office.y, obstacles.billBoard_office.width, obstacles.billBoard_office.height)
            ctx.drawImage(billBoard_homeSprite, obstacles.billBoard_home.x, obstacles.billBoard_home.y, obstacles.billBoard_home.width, obstacles.billBoard_home.height)
            ctx.drawImage(billBoard_playgroundSprite, obstacles.billBoard_playground.x, obstacles.billBoard_playground.y, obstacles.billBoard_playground.width, obstacles.billBoard_playground.height)
            ctx.drawImage(billBoard_gardenSprite, obstacles.billBoard_garden.x, obstacles.billBoard_garden.y, obstacles.billBoard_garden.width, obstacles.billBoard_garden.height)
            ctx.drawImage(rockSprite, obstacles.rock1.x, obstacles.rock1.y, obstacles.rock1.width, obstacles.rock1.height)
            ctx.drawImage(rockSprite, obstacles.rock2.x, obstacles.rock2.y, obstacles.rock2.width, obstacles.rock2.height)
            
        }
       
        const movePlayer = () => {
    
            //console.log("should move");
            if (
              keys[38] &&
              player.y > ((canvasStates.height * 52) / 100) &&
              isModalOpen === false
            ) {
              //console.log("move to up");
              player.y -= player.speed;
              player.frameY = 3;
              player.moving = true;

              if (collisionDetectionWithBuilding(player)) {
                player.y += player.speed;
              }
            }
            if(keys[37] && player.x > 0 && isModalOpen === false){
                player.x -= player.speed;
                player.frameY = 1
                player.moving = true
                
                if(collisionDetectionWithBuilding(player)){
                    player.x += player.speed;
                }
            }
            if(keys[40] && player.y < canvas.height-player.height && isModalOpen === false){
                player.y += player.speed;
                player.frameY = 0
                player.moving = true
                
                if(collisionDetectionWithBuilding(player)){
                    player.y -= player.speed;
                }
        
            }
            if(keys[39] && player.x < canvas.width-player.width && isModalOpen === false){
                player.x += player.speed;
                player.frameY = 2
                player.moving = true
                
                if(collisionDetectionWithBuilding(player)){
                    player.x -= player.speed;
                }
        
            }
        }
        
        const handlePlayerFrame = () => {
            if(player.moving){
                if(player.frameX < 3) player.frameX++
             else player.frameX = 0
            }
             
        }




let fps, fpsInterval, startTime, now, then, elapsed;
 


const animate = () => {
    
    
    now = Date.now();
    elapsed = now - then;
    if(elapsed > fpsInterval){
        then = now - (elapsed % fpsInterval)
        ctx.clearRect(0,0, canvas.width, canvas.height)

        ctx.drawImage(background, 0, 0, canvas.width, canvas.height);

        ctx.drawImage(homeSprite, home.x, home.y, home.width, home.height)
        ctx.drawImage(schoolSprite, school.x, school.y, school.width, school.height)
        ctx.drawImage(playgroundSprite, playground.x, playground.y, playground.width, playground.height)
        ctx.drawImage(officeSprite, office.x, office.y, office.width, office.height)
        ctx.drawImage(gardenSprite, garden.x, garden.y, garden.width, garden.height)
        drawObstacles()
        // ctx.drawImage(waterFountainSprite, obstacles.waterFountain1.x, obstacles.waterFountain1.y, obstacles.waterFountain1.width, obstacles.waterFountain1.height)
        // ctx.drawImage(waterFountainSprite, obstacles.waterFountain2.x, obstacles.waterFountain2.y, obstacles.waterFountain2.width, obstacles.waterFountain2.height)
        drawSprite(playerSprite, player.width * player.frameX, player.height * player.frameY , player.width, player.height, player.x, player.y, player.width, player.height)
        
        movePlayer();
        handlePlayerFrame()
        // if(collisionDetection(player, home)){
           
        // }
        //console.log("frame updated");
        //console.log(player);
        //console.log(keys);
    }
    animationFrameId = window.requestAnimationFrame(animate)
    
}
const startAnimating = (fps) => {
    fpsInterval = 1000/fps;
    then = Date.now();
    startTime = then;
    animate();
}

startAnimating(25)

return () => {
    window.cancelAnimationFrame(animationFrameId)
  }
      }, [setCollisionOccur, collisionOccur, isModalOpen, dimensions])
   
   
      return (
        <>
          <div className="Instruction-btn-wrapper">
            <button
              className="Instruction-btn"
              onClick={() => setCollisionOccur(6)}
            >
              INSTRUCTION
            </button>
          </div>

          <canvas ref={canvasRef} width={500} height={500} />
          <img
            ref={imgRef}
            src={bk}
            alt="backgroundImage"
            style={{ display: "none" }}
          />
          <img
            ref={playerRef}
            src={playerImg}
            alt="palyer"
            style={{ display: "none" }}
          />
          <img
            ref={homeRef}
            src={homeImg}
            alt="home"
            style={{ display: "none" }}
          />
          <img
            ref={schoolRef}
            src={schoolImg}
            alt="school"
            style={{ display: "none" }}
          />
          <img
            ref={waterFountainRef}
            src={waterFountain}
            alt="waterFountain"
            style={{ display: "none" }}
          />
          <img
            ref={waterWellRef}
            src={waterWell}
            alt="WaterWell"
            style={{ display: "none" }}
          />
          <img
            ref={treeRef}
            src={treeImg}
            alt="tree"
            style={{ display: "none" }}
          />
          <img
            ref={rockRef}
            src={rockImg}
            alt="rock"
            style={{ display: "none" }}
          />
          <img
            ref={playgroundRef}
            src={playgroundImg}
            alt="playground"
            style={{ display: "none" }}
          />
          <img
            ref={officeRef}
            src={officeImg}
            alt="office"
            style={{ display: "none" }}
          />
          <img
            ref={gardenRef}
            src={gardenImg}
            alt="garden"
            style={{ display: "none" }}
          />
          <img
            ref={billBoard_officeRef}
            src={billBoard_officeImg}
            alt="billBoard_office"
            style={{ display: "none" }}
          />
          <img
            ref={billBoard_homeRef}
            src={billBoard_homeImg}
            alt="billBoard_home"
            style={{ display: "none" }}
          />
          <img
            ref={billBoard_playgroundRef}
            src={billBoard_playgroundImg}
            alt="billBoard_playground"
            style={{ display: "none" }}
          />
          <img
            ref={billBoard_gardenRef}
            src={billBoard_gardenImg}
            alt="billBoard_garden"
            style={{ display: "none" }}
          />
          {/* <Modal modalID={modalID} show={isModalOpen} onHide={hideModal} /> */}
          <Modal modalID={modalID} show={isModalOpen} onHide={hideModal} />
        </>
      );
}


export default NewCanvas